<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">

    <div v-show="!showDetails"
         class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <tiny-progress-view :visible="isLoading" text="laden"></tiny-progress-view>

      <ValidationObserver tag="div"
                          ref="importOverview"
                          v-bind:style="{'z-index': '4'}">
        <div class="layout-row pt-1 pl-1">
          <div class="layout-row">
            <lx-btn small classes="mr-1" :disabled="tableObj.loading"
                    @click="getDataForTable()"
                    icon="refresh"
                    :tooltip="$t('COMPONENT_IMPORT.OVERVIEW_TOOLTIP_REFRESH_VIEW')"
                    :label="$t('COMPONENT_IMPORT.OVERVIEW_LABEL_REFRESH_VIEW')"
                    :hide-label="true"></lx-btn>
            <lx-btn small classes="mr-1" :disabled="tableObj.loading"
                    @click.stop="openConfirmNewImportDialog"
                    icon="mdi-file-import"
                    :tooltip="$t('COMPONENT_IMPORT.OVERVIEW_TOOLTIP_NEW_IMPORT')"
                    :label="$t('COMPONENT_IMPORT.OVERVIEW_LABEL_NEW_IMPORT')"
                    :hide-label="true"></lx-btn>
          </div>

          <div class="layout-row flex mr-1">
            <lx-search-field
              :placeholder="$t('COMPONENT_IMPORT.OVERVIEW_PLACEHOLDER_SEARCH_FIELD')"
              dense
              v-model="tableObj.filterValue"
              :data-method="getDataForTable"
            ></lx-search-field>

            <div class="mx-1 flex-30">
              <v-select
                :color="compColor.primeColor"
                :label="$t('COMPONENT_IMPORT.OVERVIEW_LABEL_TUMOR_SELECTION')"
                v-model="tumorSelection"
                :items="tumorSelectionTypes"
                outlined
                multiple
                dense
                class="mb-2"
                @change="tumorSelectionIsClicked(tumorSelection)"
                :menu-props="{ bottom: true, offsetY: true }"
                hide-details
                :background-color="compColor.inputs"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{item, on, attrs}">
                  <v-list-item v-on="on" style="height: 30px;">
                    <v-list-item-action>
                      <v-simple-checkbox
                        :value="attrs.inputValue"
                        v-on="on"
                        :dark="compColor.isInDarkMode"
                        :color="compColor.primeColor"
                        :ripple="false"
                      ></v-simple-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>
                        <label :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2"
                               :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}"
                        >{{ item.text }}</label>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                  <span v-if="index === 1" class="grey--text text-caption ml-1">
                    (+{{ tumorSelection.length - 1 }} Andere)
                  </span>
                </template>
              </v-select>
            </div>

            <validation-provider tag="div"
                                 class="flex-20"
                                 name="exportPeriodFrom"
                                 rules="german_date|date_not_in_future"
                                 v-slot="{ errors }">
              <lx-datepicker
                :error="errors[0]"
                :label="$t('COMPONENT_IMPORT.EXPORT_PERIOD_FROM')"
                dense
                :background-color="compColor.inputs"
                :hide-details="!errors || errors && errors.length <= 0"
                v-model="exportPeriodFrom"
              ></lx-datepicker>
            </validation-provider>
          </div>
        </div>


        <div class="layout-row mx-1">
          <div class="pa-3 pt-2 body-2 layout-row layout-align-start-center flex-gt-sm-100"
               style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? 'red' + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? '#E53935' : 'transparent'}"
               v-if="!userCancerRegister"
          >
            <v-icon class="mr-3" size="30" :color="'#E53935'">mdi-alert</v-icon>
            <span v-if="userIsPhysician" style="font-size: 18px;" :class="'red--text darken-1'"><small>{{ $t('WARNING_MISSING_CANCER_REGISTER') }}</small></span>
            <span v-if="!userIsPhysician" style="font-size: 18px;" :class="'red--text darken-1'"><small>{{ $t('WARNING_MISSING_CANCER_REGISTER_EMPLOYEE') }}</small></span>

            <v-btn :color="'#E53935'"
                   v-if="userIsPhysician"
                   dark
                   depressed
                   class="text-none ml-4"
                   style="height: 28px;"
                   @click="openAccountTab()"
            >{{ $t('WARNING_MISSING_CANCER_REGISTER_BTN_TEXT') }}</v-btn>
          </div>
        </div>
      </ValidationObserver>

      <v-divider :style="{'border-color':compColor.lightDivider}" class="mb-2"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">

        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;" :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <lx-data-table
              tableName="ImportOverview"
              v-model="tableObj.selection"
              :items="items"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :tableOptions="tableObj.options"
              :setVisible="!showDetails"
              :hideContextFilter="true"
              :stayAtScrollPosition="true"
              @changeOptions="changeTableOptions"
              @rowClicked="openImportDetails"
              @openContextOnRowClick="openContextOnRowClick">

              <template v-slot:cellrenderer="{ value }">
                <div v-if="value.f.renderer === 'legend'" style="padding:1px;height:35px;">
                  <div class="layout-row layout-align-center-center" style="border-radius:3px;height:33px;"
                       :class="['legend-color-' + value.i.color]">
                  </div>
                </div>

                <div v-if="value.f.renderer === 'diagnosis'" style="padding:1px;height:35px;">
                  <div class="layout-row layout-align-start-center" style="border-radius:3px;height:33px;">
                    <span v-if="value.i.latestDiagnosis">{{ value.i.latestDiagnosis.primaertumor_icd_code }} ({{ value.i.latestDiagnosis.diagnosedatum | formatDate('DD.MM.YYYY') }})</span>
                  </div>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'ImportOverview'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable">
        </lx-pagination>
      </div>
    </div>

    <div v-if="showDetails" class="layout-column flex ma-1">
      <import-details @set-show-details="setShowDetails"
                      :exportPeriodFrom="exportPeriodFrom"
                      :reloadTrigger="reloadTrigger"
                      :detailId="selectedId">
      </import-details>
    </div>

    <popup-blacklist-duration
        :show-duration-popup="showDurationDialog"
        @set-show-blacklist-duration-dialog="ignorePatientForever">
    </popup-blacklist-duration>
  </div>
</template>

<script>
import LxPagination from '../../components/lx_pagination/LxPagination'
import ImportDetails from './ImportDetails'
import PopupBlacklistDuration from '../../components/patients/PopupBlacklistDuration.vue'

import utils from "../../common/utils"

export default {
  name: 'ImportOverview',
  mixins: [utils],
  data () {
    return {
      tableObj: {
        loading: false,
        options: {
          sortBy: ['lastname'],
          sortDesc: [false],
        },
        selection: null,
        filterValue: null,
        headers: [
          {
            text: 'AIS ID',
            value: 'patientAisId',
            width: '100px',
            sortable: true
          },
          {
            text: 'Nachname',
            value: 'lastname',
            width: '200px',
            sortable: true
          },
          {
            text: 'Vorname',
            value: 'firstname',
            width: '200px',
            class: 'pinned',
            sortable: true
          },
          {
            text: 'Geburtstag',
            value: 'birthday',
            width: '150px',
            renderer: 'date',
            sortable: true
          },
          {
            text: 'Geschlecht',
            value: 'gender',
            width: '100px',
            renderer: 'gender',
            class: 'text-center',
            sortable: true
          },
          {
            text: 'Letzter Praxisbesuch',
            value: 'lastVisit',
            width: '150px',
            renderer: 'date',
            sortable: true
          },
          {
            text: 'Zuletzt bearbeitet am',
            value: 'lastModified',
            width: '150px',
            renderer: 'date',
            sortable: true
          },
          {
            text: 'Letzte Bestandsdiagnose',
            value: 'latestDiagnosis',
            width: '150px',
            renderer: 'diagnosis',
          }
        ]
      },
      selectedId: '',
      items: [],
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      reloadTrigger: false,
      isLoading: false,
      showDetails: false,
      confirmStartNewImportDialogTitle: this.$t('CONFIRM_START_NEW_IMPORT_DIALOG.HEADER'),
      confirmStartNewImportDialogMessage: this.$t('CONFIRM_START_NEW_IMPORT_DIALOG.MESSAGE'),
      confirmStartNewImportDialogOpts: {
        ok: this.$t('buttons.start_new_import.value'),
        cancel: this.$t('buttons.cancel.value')
      },
      exportPeriodFrom: null,
      tumorSelection: ['all'],
      tumorSelectionTypes: [
        { value: 'all', text: 'Alle Tumore' },
        { value: 'dermatological_melanomas', text: 'Dermatologie Melanome & Co.' },
        { value: 'dermatological_non_melanotic', text: 'Dermatologie nicht-melanotisch' },
        { value: 'gastroenterological', text: 'Gastroenterologie' },
        { value: 'gynaecological', text: 'Gynäkologie' },
        { value: 'pneumological', text: 'Pneumologie' },
        { value: 'urological', text: 'Urologie' }
      ],
      mappingLANR: {
        '15': ['gynaecological'],
        '16': ['gynaecological'],
        '21': ['dermatological_melanomas', 'dermatological_non_melanotic'],
        '26': ['gastroenterological'],
        '17': ['gynaecological'],
        '30': ['pneumological'],
        '67': ['urological']
      },
      showDurationDialog: false,
      selectedPatientForIgnore: null
    }
  },
  components: {
    ImportDetails,
    LxPagination,
    PopupBlacklistDuration
  },
  created () {
    const user = (this.authStore.getters.getAuthUserData || {}).user

    // physician and employee has physicians-array with physician as first element
    if (user?.cancer_form_details?.medicalCommunity?.physicians[0]?.lanr) {
      // get last 2 characters from lanr
      const professionNumber = user.cancer_form_details.medicalCommunity.physicians[0].lanr.substr(user.cancer_form_details.medicalCommunity.physicians[0].lanr.length - 2)
      // if last to characters of LANR match with profession of tumor selection, set it as default

      if (professionNumber && this.mappingLANR[professionNumber]) {
        this.tumorSelection = this.mappingLANR[professionNumber]
      }
    }
  },
  mounted () {
    if (typeof this.createCategory === "function" && typeof this.addEntryToMenu === "function") {
      this.createCategory('ImportDataTable')
      this.addEntryToMenu({
        type: 'ImportDataTable',
        value: [
          {
            icon: true,
            iconName: 'mdi-clipboard-edit-outline',
            title: this.$t('COMPONENT_IMPORT.OVERVIEW_CONTEXT_MENU_EDIT'),
            action: this.openImportDetails
          },
          {
            icon: true,
            iconName: 'mdi-delete-outline',
            title: this.$t('COMPONENT_IMPORT.OVERVIEW_CONTEXT_MENU_IGNORE_ONCE'),
            action: this.ignorePatientForCurrentImport
          },
          {
            icon: true,
            iconName: 'mdi-ghost',
            title: this.$t('COMPONENT_IMPORT.OVERVIEW_CONTEXT_MENU_IGNORE_EVER'),
            action: this.openIgnoreDurationDialog
          },
        ]
      })
    }
  },
  props: {
    reloadTable: {
      type: Boolean
    }
  },

  methods: {
    /**
     * Open tab of physician-account to edit cancer register details
     */
    openAccountTab () {
      this.addTabToStore({
        routeName: 'AccountDetails',
        options: {
          headline: 'Account',
          icon: 'mdi-account-circle'
        }
      })
    },

    /**
     * Modify element of tumorSelection in dependency to selection, either 'all' or specific selection
     */
    tumorSelectionIsClicked (list) {
      // if all elements are de-selected, list will be filled with default value ['all']
      if (list.length === 0) list.push('all')

      // if last checked element is not 'all' and 'all' exists, delete this from list
      if (list[list.length - 1] !== 'all' && list.indexOf('all') > -1) {
        list.splice(list.indexOf('all'), 1)
      }

      // if last clicked element is 'all' and other elements exist, then list will be filled only with default ['all']
      if (list[list.length - 1] === 'all' && list.length > 1) {
        this.$set(this, 'tumorSelection', ['all'])
      }

      this.getDataForTable()
    },

    /**
     * Open modal to confirm if new import should be initialized and old import should be deleted
     */
    openConfirmNewImportDialog () {
      this.DialogConfirm(
        this.confirmStartNewImportDialogTitle,
        this.confirmStartNewImportDialogMessage,
        this.confirmStartNewImportDialogOpts)
        .then(() => {
          this.startNewImport()
        })
        .catch(() => {})
    },

    /**
     * Open special context menu for selected patient
     *
     * @param event The opening event
     * @param item The patient value
     */
    openContextOnRowClick (event, item) {
      if (item) {
        this.$lxContext.open(event, 'ImportDataTable', item, this.isLxContextDisabled)
      }
    },

    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * Open detail view of selected patient
     *
     * @param params The patient value
     */
    openImportDetails (params) {
      if (params?._id) {
        this.selectedId = params._id
        this.setShowDetails(true)
      }
    },

    /**
     * Set flag on patient to ignore only for this import
     *
     * @param params The patient value
     */
    ignorePatientForCurrentImport (params) {
      if (params?._id) {
        this.$http.put('/import/patient/ignore', {id: params._id, type: 'once'})
          .then(() => {
            this.getDataForTable()
          })
          .catch(this.NotifyError)
      }
    },

    /**
     * Open dialog to select duration of ignoring for import
     *
     * @param params The data of selected patient
     */
    openIgnoreDurationDialog (params) {
      if (params?._id) {
        this.selectedPatientForIgnore = params._id
        this.showDurationDialog = !this.showDurationDialog
      } else {
        this.selectedPatientForIgnore = null
      }
    },

    /**
     * Set flag on patient to ignore for every import
     *
     * @param params The patient value
     */
    ignorePatientForever (params) {
      if (this.selectedPatientForIgnore && params) {

        let requestData = {
          id: this.selectedPatientForIgnore,
          type: 'permanent'
        }

        if (params.date !== null) {
          requestData.type = 'addUntil'
          requestData.date = params.date
        }

        this.$http.put('/import/patient/ignore', requestData)
          .then(() => {
            this.showDurationDialog = false
            this.selectedPatientForIgnore = null

            this.getDataForTable()
          })
          .catch(this.NotifyError)
      } else {
        this.showDurationDialog = false
        this.selectedPatientForIgnore = null
      }
    },

    /**
     * Get all patients in import from db
     */
    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      } else {
        this.pagingOptions.limit = 50
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      // set search value only if filter value has content, else clear filter value (e.g. string has only spaces)
      if (this.tableObj.filterValue && this.tableObj.filterValue.replace(/\s/g, '').length > 0) {
        query.search = this.clearStringForRegexSearch(this.tableObj.filterValue)
      } else {
        this.tableObj.filterValue = null
      }

      if (this.exportPeriodFrom) {
        query.from = this.exportPeriodFrom
      }

      if (this.tumorSelection && this.tumorSelection.length > 0) {
        query.tumorSelection = this.tumorSelection
      }

      this.$http.get('/import/data?config={"opts":' + JSON.stringify(opts) + ', "query": ' + JSON.stringify(query) + '}')
        .then(res => {
          if (res.data) {
            this.items = res.data.items || []

            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    /**
     * Reset current import and remove uploaded files
     */
    startNewImport () {
      if (this.isLoading) return
      this.isLoading = true

      this.$http.put('/import/reset')
        .then(() => {
          this.item = []

          // Trigger 'checkPendingImport()' on parent
          this.$emit('check-pending-import')
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.isLoading = false
        })
    },

    setShowDetails (showDetails) {
      // reload overview eg. after import
      if (!showDetails) {
        // trigger 'checkPendingImport()' on parent
        this.$emit('check-pending-import')
      }
      this.showDetails = showDetails
    }
  },

  computed: {
    userCancerRegister () {
      return this.getUserCancerRegisterDetails().register_id
    },

    userIsPhysician () {
      return this.authStore.getters.userIsPhysician
    }
  },

  watch: {
    '$route' (to) {
      if (to.name === 'Import') {
        if (this.showDetails) {
          // trigger reload details view
          this.reloadTrigger = !this.reloadTrigger
        } else {
          // trigger 'checkPendingImport()' on parent
          this.$emit('check-pending-import')
        }
      }
    },
    reloadTable () {
      this.getDataForTable()
    },
    exportPeriodFrom (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getDataForTable()
      }
    }
  }
}
</script>
